import { Typography } from "@mui/material"

type Props = {}

const EnableNotificationsLabel = (props: Props) => {
  return <Typography variant="body1">Enable Notifications</Typography>
}

export default EnableNotificationsLabel
